// import { StylesConfig } from "react-select";

// interface ColourOption {
//   readonly value: string;
//   readonly label: string;
//   readonly color: string;
//   readonly isFixed?: boolean;
//   readonly isDisabled?: boolean;
// }
 
export const colourStyles: any = {
    option: (styles:any, { isDisabled, isFocused, isSelected }:any) => {
      return {
        ...styles,
        backgroundColor: isDisabled
          ? "transparent"
          : isSelected
            ? "#e0e0e0"
            : isFocused
              ? "#e5e5e5"
              : "transparent",
        padding:0,
        color: isDisabled ? "#ccc" : isSelected ? "#000" : "#000",
        ":active": {
          ...styles[":active"],
          backgroundColor: !isDisabled
            ? isSelected
              ? "#e0e0e0"
              : "#e5e5e5"
            : "transparent"
        }
      };
    },
    valueContainer: (base:any) => ({
      ...base,
      flexWrap: "nowrap",
      maxWidth: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis",
    }),
    control: (styles:any, { isFocused, isDisabled }:any) => ({
      ...styles,
      borderRadius: 0,
      backgroundColor: "#fff",
      opacity: isDisabled ? 0.5 : 1,
      border:"none",
      boxShadow: "none",
      borderBottom: "1.5px solid #8d8d8d",
      outline: isFocused ? "2px solid #0f62fe" : "",
      outlineOffset: "-2px",
      ...(isDisabled && {
        pointerEvents: "auto",
        cursor: "not-allowed"
      })
    }),
    menu: (base:any) => ({
      ...base,
      marginTop:0,
      paddingTop:0,
      borderRadius:0,
      backgroundColor:"#f4f4f4",
    }),
    menuList: (base:any) => ({
      ...base,
      padding:0,
    }),
    indicatorSeparator:(base:any, {selectProps:{isMulti,isSearchable}}:any) => {
      if(!isMulti && !isSearchable) return {display:"none"};
      return {...base};
    },
    dropdownIndicator:(base:any) => {
      return {
        ...base,
        cursor:"pointer"
      };
    },
    multiValueRemove: (base:any, {isDisabled}:any) => {
      return isDisabled ? { ...base, display: 'none' } : base;
    }
  };
  